import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { render } from 'react-dom';

let resolve: any;
const defaultProps = {
  title: 'Confirmation',
  message: 'Are you sure?'
};

interface Props {
  createConfirmProps: any;
}

export class Confirm extends Component<Props> {
  static create(props: any = {}) {
    const containerElement = document.createElement('div');
    document.body.appendChild(containerElement);
    return render(<Confirm createConfirmProps={props} />, containerElement);
  }

  state: {
    isOpen: boolean;
    showConfirmProps: any;
  }

  constructor(props: Props){
    super(props);
    
    this.state = {
      isOpen: false,
      showConfirmProps: {},
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.show = this.show.bind(this);
  }

  handleCancel() {
    this.setState({ isOpen: false });
    resolve(false);
  }

  handleConfirm() {
    this.setState({ isOpen: false });
    resolve(true);
  }

  show(props = {}) {
    const showConfirmProps = { ...this.props.createConfirmProps, ...props };
    this.setState({ isOpen: true, showConfirmProps });
    return new Promise((res) => {
      resolve = res;
    });
  }

  render(){
    const { isOpen, showConfirmProps } = this.state;
    const { message } = showConfirmProps;
    return (
      <Modal show={isOpen} onHide={this.handleCancel}>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: message || defaultProps.message }}/>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary btn-sm" onClick={this.handleConfirm}>OK</button>
          <button className="btn btn-sm" onClick={this.handleCancel}>Cancel</button>
        </Modal.Footer>
      </Modal>
    )
  }
}